import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialpadAiReversed",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, r, p, _, e) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--dialpad-ai-reversed"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Dialpad Ai Reversed",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.65 0A2.65 2.65 0 0 0 0 2.65v6.7A2.65 2.65 0 0 0 2.65 12h6.7A2.65 2.65 0 0 0 12 9.35v-6.7A2.65 2.65 0 0 0 9.35 0h-6.7Zm6.525 4.175a.654.654 0 1 0 0-1.307.654.654 0 0 0 0 1.307Zm-4.237-.133c-.15 0-.409.143-.544.583L3.118 8.739a.519.519 0 1 1-.99-.307l1.274-4.11V4.32c.208-.676.751-1.316 1.536-1.316s1.328.638 1.536 1.313v.001l.982 3.166c.135.44.393.582.544.582a.667.667 0 0 0 .667-.667V5.23a.519.519 0 1 1 1.037 0V7.4c0 .941-.763 1.705-1.704 1.705-.784 0-1.328-.639-1.536-1.314l-.982-3.166v-.001c-.135-.439-.393-.581-.544-.581Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const A = /* @__PURE__ */ o(c, [["render", u]]);
export {
  A as default
};
//# sourceMappingURL=dialpad-ai-reversed.js.map
